import React from 'react';
import {uiStore} from '../stores/ui';

const uiStoreContext = React.createContext(uiStore);
export const useUiStore = () => React.useContext(uiStoreContext);
